import ApplicationSerializer from 'admin-panel/serializers/application';

import type Model from '@ember-data/model';

export default class IntegrationsConfigurationSerializer extends ApplicationSerializer {
  attrs = {
    currentConfig: { serialize: false },
    version: { serialize: false },
    hotelUuid: { serialize: false },
  };

  normalize(typeClass: Model, hash: Record<string, unknown>, _prop: string) {
    if (hash['current_config'] === null) {
      delete hash['current_config'];
    }

    return super.normalize(typeClass, hash, _prop);
  }
}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'integrations/configuration': IntegrationsConfigurationSerializer;
  }
}
